import { apiGet } from './api';

/**
 * Info do GM logado — usado pelo AuthContext pra decidir o que mostrar
 * no painel administrativo. Vem de GET /api/auth/gm-info.
 *
 * gmLevel:
 *   0  = sem acesso GM
 *   1  = GM1 (dashboard, online, contas, ban)
 *   2  = GM2 (+ send item, monitor, edit character)
 *   3  = GM3 (+ news, premium, kits)
 *   4  = GM4 (+ recargas view/aprovar, GM logs, edit cash)
 *   99 = SUPER (Liberty — tudo + gateways + acessos)
 */
export interface GmInfo {
  userNum: number;
  username: string;
  gmLevel: number;
  isSuper: boolean;
  features: string[];
}

export const getGmInfo = () => apiGet<GmInfo>('/auth/gm-info');
